var _g, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveStream(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      strokelinecap: "round",
      strokelinejoin: "round",
      strokewidth: 2,
      stroke: "#de6139",
      fill: "none",
      strokeMiterlimit: 10
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#de6139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.5 15.5c2-2 2-5.1 0-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.4 18.4c3.5-3.5 3.5-9.2 0-12.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.5 15.5c-2-2-2-5.1 0-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.6 18.4c-3.5-3.5-3.5-9.2 0-12.7"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveStream);
export default __webpack_public_path__ + "static/media/live-stream.0a885e25.svg";
export { ForwardRef as ReactComponent };